import type { ReactNode } from 'react';
import React from 'react';

import type { IconTypes } from 'components-new/icon/icon.types';

export type RouteType = {
  id: number;
  isSelected?: boolean;
  icon: IconTypes;
  label: string;
  name: string;
  src: string;
};

export type RouteGroup = {
  name: string;
  label: string;
  routes: RouteType[];
};

export interface OrganisationSideBarProps {
  content: ReactNode | undefined;
}

const OrganisationSideBar: React.FC<OrganisationSideBarProps> = ({
  content,
}) => {
  return (
    <div>
      <aside
        className="relative border-r-2 border-gray100 h-full"
        aria-label="Sidebar"
      >
        <div className="h-full hidden md:block px-6 py-4 overflow-y-auto">
          {content}
        </div>
      </aside>
    </div>
  );
};

export default OrganisationSideBar;
